import { SCREEN_PRESENTER, UNASSIGNED } from '@studio/constants/Sources';
import { getProgramLayers } from '@studio/program/utils/getProgramLayers';
import {
  toggleProgramSource,
  decreaseScreenShare
} from '@shoflo/studio-redux/actions';
import { updateSource } from 'actions/source';
import { setProgram } from 'actions/program';

async function agoraScreenShareStopped({ getState, dispatch }, { attendeeId }) {
  const { broadcastSources, program } = getState();

  const source = broadcastSources?.sources?.find(s => s.value === attendeeId);

  if (source) {
    const layers = getProgramLayers(program);
    const [layerSource] = layers.filter(
      layer => layer.source._id === source._id
    );

    if (layerSource) {
      dispatch(toggleProgramSource(source, setProgram));
    }

    dispatch(updateSource(source._id, { value: UNASSIGNED }));

    if (source.type === SCREEN_PRESENTER) {
      dispatch(decreaseScreenShare());
    }
  } else {
    // Even if source doesn't exist (e.g., user cancelled from browser picker),
    // we still need to decrement the screen share count.
    // The count was incremented when director approved the request,
    // but source was never created because presenter cancelled.
    dispatch(decreaseScreenShare());
  }
}

export default agoraScreenShareStopped;
